const rawSupportPhone = process.env.REACT_APP_SUPPORT_PHONE || "";

export const supportContact = {
  phone: rawSupportPhone,
  whatsappUrl: rawSupportPhone ? `https://wa.me/${rawSupportPhone.replace(/^\+/, "")}` : "",
  displayPhone: rawSupportPhone ? `+${rawSupportPhone.replace(/^\+/, "")}` : "Nao configurado",
};
